import React from 'react';
import CatalogoP from '../catalagobase/catalogobase';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';
import { API_URLS } from '../../Services/servicioURL';

function Lineas() {
    return (
        <div>
            <Navbar />
            <Sidebar />
            <CatalogoP title="Lineas" apiUrls={API_URLS.lineas}/>
        </div>
        
    
    );
}

export default Lineas;